<style>
    .cloudBox{
        width: 1440px;
        height: auto;
        padding: 20px 0;
        margin: 0 auto;
        text-align: left;
    }
    .head{
        font-family: PingFang SC;
        display: flex;
        justify-content: space-between;
    }
    .head .rightBox span:nth-child(1){
        width:202px;
        height:30px;
        font-size:22px;
        font-weight:bold;
        line-height:30px;
        color:rgba(77,77,77,1);
    }
    .head .rightBox span:nth-child(2){
        width:202px;
        height:30px;
        font-size:16px;
        font-weight:400;
        line-height:30px;
        color:rgba(77,77,77,1);
        display: inline-block;
        margin-left: 20px;
    }
    .midSearch{
        width: 600px;
        height:30px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 6px rgba(153,152,155,0.16);
        border-radius:50px;
        position: relative;
    }
    .midSearch input{
        position: absolute;
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(153,153,153,1);
        left: 0;
        top: 0;
        background: none;
        border: none;
        padding: 0 60px;
    }
    .midSearch .clearSearch{
        width: 10px;
        height: 10px;
        position: absolute;
        right: 40px;
        top: 10px;
        cursor: pointer;
    }
    .myinfo{
        font-size:16px;
    }
    .balance{
        width:190px;
        height:22px;
        font-weight:400;
        line-height:30px;
        color:rgba(51,51,51,1);
    }
    .record{
        height:22px;
        font-weight:500;
        line-height:22px;
        color:rgba(81,71,231,1);
        display: inline-block;
        margin-left: 6px;
        cursor: pointer;
    }
    .share{
        width: 100%;
        height: 50px;
        margin-top: 28px;
    }
    .share .shareBtn{
        width:100px;
        height:32px;
        border:1px solid rgba(81,71,231,1);
        border-radius:6px;
        text-align: center;
        line-height: 32px;
        color:rgba(81,71,231,1);
        cursor: pointer;
        float: right;
    }
    .storeBox{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .storeBox .storeList{
        width:30%;
        height:202px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 6px rgba(153,152,155,0.16);
        border-radius:10px;
        padding: 20px 25px;
        margin: 0 5% 30px 0;
    }
    .storeBox .storeList:nth-of-type(3n){
        margin: 0 0 30px 0;
    }
    .storeList{
        display: flex;
        margin-bottom: 20px;
    }
    .storeList .left{
        min-width: 170px;
        height: 145px;
        background-image: url('../assets/timg.png');
        background-size: 100% 100%;
        text-align: center;
        line-height: 145px;
        font-size:22px;
        font-weight:bold;
    }
    .storeList .right{
        margin-left: 44px;
    }
    .storeList .right ul{
        display: flex;
    }
    .storeList .right ul li{
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-size: 15px;
        color:rgba(255,255,255,1);
        background:rgba(184,194,212,1);
        border-radius:4px;
        margin-right: 20px;
        padding: 0 10px;
        
    }
    .storeList .right .stock{
        margin-top: 14px;
    }
    .storeList .right .stock .nowStock{
        color: #F25E5E;
        font-size:18px;
        font-weight:500;

    }
    .seeStock{
        display: inline-block;
        margin-left: 30px;
        font-size:16px;
        font-weight: 500;
        color:rgba(81,71,231,1);
    }
    .storeAddress{
        margin-top: 10px;
        font-size:18px;
        font-weight:500;
        color:rgba(102,102,102,1);
    }
    .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background:rgba(75,75,75,1);
        opacity:0.3;
    }
    .messageBox{
        width:574px;
        height:372px;
        background-color:rgba(52,51,52,1);
        box-shadow:0px 3px 6px rgba(0,0,0,0.16);
        opacity:0.95;
        border-radius:8px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-237px,-186px);
        z-index: 1;
        color: #fff;
    }
    .shareTitle{
        text-align: center;
        font-family: PingFang SC;
        font-weight:400;
        position: relative;
        margin-top: 20px;
    }
    .shareTitle .shareBoxDown{
        position: absolute;
        right: 10px;
        top: -15px;
    }
    .formBox{
        padding: 30px 24px;
        font-size:16px;
    }
    .formBox form{
        width: 100%;
        height: 100%;
    }
    .formBox form>div{
        margin-bottom: 20px;
    }
    .formBox .formTitle{
        display: inline-block;
        width: 80px;
    }
    .formBox .inputText{
        width:395px;
        height:30px;
        border:1px solid rgba(217,221,225,1);
        opacity:1;
        background:rgba(52,51,52,1);
        border-radius:4px;
        color: #fff;
        text-indent: 6px;
    }
    .formBox .checkbox{
        background:rgba(52,51,52,1);
    }
    .formBox .textarea{
        height: 60px;
    }
    .submitBtn{
        margin: 0 36%;
    }
    .submitBtn>input{
        text-align: center;
        border: none;
        font-size:16px;
        color: #fff;
        width:145px;
        height:40px;
        background:rgba(81,71,231,1);
        opacity:1;
        border-radius:10px;
        cursor: pointer;
    }
    .need{
        color:rgba(255,110,110,1);
    }
    input[type='checkbox']{
        width: 20px;
        height: 20px;
        /* -webkit-appearance: none; */
        background-color: #fff;
        border: 1px solid #c9c9c9;
        border-radius: 2px;
        outline: none;
        vertical-align: middle
    }
    /* input[type="checkbox"]:checked{
       background: #627BF6 
    } */
    .cursor{
        cursor: pointer;
    }
    .checkLable{
        line-height: 20px;
        display: inline-block;
        padding: 0 4px;
    }
    @media screen and (max-width:500px){
        .cloudBox{
            width: 100%;
            padding: 50px 0;
        }
        .storeBox .storeList{
            padding: 20px 10px;
            height: 140px;
        }
        .head{
            display: block;
            padding: 0 10px;
        }
        .rightBox{
            float: left;
        }
        .head .rightBox span:nth-child(1){
            font-size: 14px;
            height: 20px;
            line-height: 20px;
        }
        .head .rightBox span:nth-child(2){
            font-size: 12px;
            margin-left: 0;
            display: block;
            height: 20px;
            line-height: 20px;
        }
        .midSearch{
            float: left;
            width: 150px;
        }
        .midSearch input{
            padding: 0 10px;
        }
        .myInfo{
            float: right;
            font-size: 12px;
        }
        .share{
            margin-top: 0;
            height: 30px;
        }
        .share .shareBtn{
            width: 90px;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            margin-right: 10px;
        }
        .storeList .left{
            width: 100px;
            height: 100px;
            font-size: 12px;
            line-height: 100px;
            display: flex;
            align-items: center;
            background-size: 100px 100px;
        }
        .storeList .left p{
            width: 100%;
            line-height: 20px;
            text-align: center;
        }
        .storeList .right{
            margin-left: 10px;
        }
        .storeList .right ul li {
            height: 22px;
            line-height: 22px;
            font-size: 12px;
            margin-right: 6px;
            padding: 0 2px;
        }
        .storeList .right .stock {
            margin-top: 8px;
            font-size: 14px;
        }
        .storeList .right .stock .nowStock {
            font-size: 14px;
        }
        .seeStock {
            display: inline-block;
            margin-left: 30px;
            font-size: 12px;
        }
        .storeAddress {
            margin-top: 10px;
            font-size: 14px;
        }       
    }
    .pageBtns{
        margin-left: 600px;
    }
    .pageBtn{
        width: 80px;
        height: 40px;
        cursor: pointer;
    }
    .pageBtn:disabled{
        cursor: no-drop;
    }
</style>
<template>
    <div class="cloudBox">
        <div class="head">
            <div class="rightBox">
                <span>柜柜云仓，仓库共享</span>
                <span>全国用户：{{identityCount}}</span>
            </div>
            <div class="midSearch">
                <div class='searchLogo'>
                    <img src="../assets/searchlogo.png" alt="">
                </div>
                <input type="text" v-model='keyword'>
                <img src="../assets/searchclose.png" alt="" class='clearSearch' v-show='keyword!=""' @click='keyword=""'>
                <img src="../assets/searchbtn.png" alt="" class='searchBtn' @click='searchKeyword'>
            </div>
            <div class="myInfo">
                <span class="balance">我的云仓余额：{{balance}}元</span>
                <span class="record cursor" @click="toSeeRecord">消费记录 ></span>
            </div>
           
        </div>
        <div class="share">
            <div class="shareBtn" @click="shareBoxShow">
                申请加盟云仓
            </div>
        </div>
        <!-- <div class="storeBox">
            <div class="storeList" v-for="item in storeInfo">
                <div class="left">
                    <p>{{item.name}}</p>
                </div>
                <div class="right">
                    <ul>
                        <li v-for='items in item.tags'>{{items}}</li>
                    </ul>
                    <div class="stock">仓库现货：<span class="nowStock">{{item.stock_num}}</span><span class="seeStock cursor" @click="seeStore">查看库存 ></span></div>
                    <div class="storeAddress">仓库地址：{{item.address}}</div>
                </div>
            </div>
        </div> -->
        <!-- 循环模块 -->
         <div class="storeBox">
            <div class="storeList" v-for="(item,index) in supplierInfo" :key="index">
                <div class="left">
                    <p>{{item.name}}</p>
                </div>
                <div class="right">
                    <ul>
                        <li v-for='(items,index) in item.project' :key="index">{{items}}</li>
                    </ul>
                    <div class="stock">仓库现货：
                        <span class="nowStock">
                            <!-- {item.stock_num}} -->1000万元
                        </span>
                    
                    <!-- <span class="seeStock cursor" @click="seeStore">查看库存 ></span> -->
                </div>
                    <div class="storeAddress">仓库地址：{{item.address}}</div>
                </div>
            </div>
        </div>
        <div class="pageBtns" v-if="this.all_page>1">
            <button @click="toPreviousPage"  class="pageBtn"  :disabled="previousDisabled">上一页</button>
            <button @click="toNextPage"  class="pageBtn"  :disabled="nextDisabled">下一页</button>
        </div>


        <div class="bg" v-if="showBg" @click="shareBoxDown"></div>
        <div class="messageBox" v-if="showMessageBox">
            <div class="shareTitle"><span>需要提交后台审核</span><span class="shareBoxDown cursor" @click="shareBoxDown"><img src="../assets/icon_chacha.png" alt=""></span></div>
            <div class="formBox">
                <form>
                    <div><span class="need">*</span><span class="formTitle">云仓名：</span><input class="inputText" v-model="shareInfo.name" type="text"></div>
                    <div><span class="need">*</span><span class="formTitle">经营范围：</span>
                        <label for="" class="checkLable" v-for="(item,index) in checkValue" :key="index"><input class="checkbox" type="checkbox" name="menu" :value="item" v-model="shareInfo.checkedNames">&nbsp;{{item}}</label>
                    </div>
                    <div><span class="need">*</span><span class="formTitle">仓库地址：</span><input class="inputText " v-model="shareInfo.address" type="text"></div>
                    <div><span class="need">*</span><span class="formTitle">仓库现货：</span><input class="inputText" v-model="shareInfo.stock_num" type="number">&nbsp;万元</div>
                    <div><span class="need">*</span><span class="formTitle">联系电话：</span><input class="inputText " v-model="shareInfo.phone" type="text"></div>
                    <div class="submitBtn"><input type="button" @click="submitBtn" value="确认"></div>
                </form>
            </div>
        </div>
        <!-- <div class="point">您的申请已提交成功，正在审核中</div> -->
    </div>
</template>
<script>
export default {
    components:{

    },
    props:[],
    data(){
        return {
            checkValue:['板材','拆单','数控设备','封边条','五金'],
            keyword:'',
            status:1,
            balance:0,
            // storeInfo:[],
            supplierInfo:[],
            showBg:false,
            showMessageBox: false,
            shareInfo:{
                name:'',
                stock_num:'',
                address:'',
                checkedNames:[],
                phone:''
            },
            page:1, 
            pageData:'',
            all_page:'',
            // previousDisable:true,
            // nextDisable:true
            nextDisabled:true,
            previousDisabled:true,
            limit:12,
            status:1,
            project:'',
            identity:'',
            supplierIdentity:2, //供应商身份
            identityCount:0,

        }
    },
    computed:{
             
    },
    mounted: async function(){
        // let that = this;
        this.serach()
        this.getIdentityCount()
    },
    methods:{
        getIdentityCount(){
            this.axios.get('https://guigui.admin.thinkerx.com/eggrj/user_count',{}).then(res => {
                this.identityCount = res.data.data.res
            })
        },
        getIdentity(identity){
            this.supplierIdentity = identity
            this.page = 1
            this.serach()
            // console.log(this.page,this.all_page)
        },
        pageNumnext(){
            if(this.page>=this.all_page){
                this.nextDisabled=true
            }else{
                this.nextDisabled=false
            }
            // console.log(this.page,"当前页数")
            // console.log(this.all_page,"所有页数")
        },
        pageNumpre(){
            if(this.page>1){
                this.previousDisabled=false
            }else{
                this.previousDisabled=true
            }
        },
        toPreviousPage(){
            this.page=this.page-1
            // console.log(this.page,"前一页")
            this.serach()
            this.pageNumpre()
            this.pageNumnext()

        },
        toNextPage(){
            this.page=this.page+1
            this.serach()
            this.pageNumpre()
            this.pageNumnext()
        },                   
        searchKeyword(){
            this.serach()
        },
        serach(){
            let that = this;
            // that.$post('/cloudStorage/getStorageList', {
            //     keywords:that.keyword,
            //     status: that.status
            // }, res => {
            //     let data = res.data.list;
            //     data.forEach(item => {
            //         if(typeof item.tags == 'string'){
            //             item.tags = item.tags.split(',')
            //         }
            //     })
            //     that.storeInfo = data
            // })

            that.$post('/guigui/cloudStorage/getSupplierList', {
                page:that.page,
                limit:that.limit,
                status:that.status,
                identity:this.supplierIdentity
            }, res => {
                let data = res.data.list;
                data.forEach(item => {
                    if(typeof item.project == 'string'){
                        item.project = item.project.split(',')
                    }
                })
                that.supplierInfo = data
                // that.supplierInfo = data.filter(item => {
                //     if(item.identity == this.supplierIdentity){
                //         return item
                //     }
                // })
                that.all_page=res.data.all_page                
            })

            
        },
        shareBoxShow(){
            this.showMessageBox = true;
            this.showBg = true
        },
        shareBoxDown(){
            this.showMessageBox = false
            this.showBg = false
        },
        submitBtn(){
            let name = this.shareInfo.name;
            let address = this.shareInfo.address;
            let tags = this.shareInfo.checkedNames.join(',');
            let stock_num = this.shareInfo.stock_num;
            let phone = this.shareInfo.phone;
            let uid = '';
            if(localStorage.getItem('data')){
                uid = JSON.parse(localStorage.getItem('data')).id
            }
            var phoneReg = new RegExp("^[1][0-9]{10}$");
            if(!name){
                this.$message({
                    message:'请填写云仓名',
                    type:'error'
                })
                return
            }else if(!tags){
                this.$message({
                    message:'请勾选经营范围',
                    type:'error'
                })
                return
            }else if(!address){
                this.$message({
                    message:'请填写仓库地址',
                    type:'error'
                })
                return
            }else if(!stock_num){
                // if()
                this.$message({
                    message:'请填写仓库现货',
                    type:'error'
                })
                return
            }else if(!phone || !phoneReg.test(phone)){
                this.$message({
                    message:'请填写正确的联系电话',
                    type:'error'
                })
                return
            }else{
                let reqData = {
                    name,
                    // address,
                    // tags,
                    // stock_num:stock_num+'万元',
                    phone,
                    uid,
                    identity: 1
                }
                this.$post('/guigui/cloudStorage/addSupplier',reqData, res => {
                    this.$message({
                        message:'您的申请已提交成功，正在审核中',
                        type: 'success'
                    })
                    
                    this.shareInfo = {
                        name:'',
                        address:'',
                        stock_num:'',
                        checkedNames:[],
                        phone:''
                    }
                    this.shareBoxDown()
                })
            }
        },
        toSeeRecord(){
            this.$message({
                message:'功能开发中',
                duration: 1000
            })
        },
        seeStore(){
            this.$message({
                message:'功能开发中',
                duration: 1000
            })
        }
    }
}
</script>